import { BOTTOM_MENU_DATA } from "../Components/HelpandSupport/action";
import { ORDER_DATA, WEB_SOCKET_DATA } from "./webSocketAction";

const initialState = {
  WebSocketData: "",
  OrderData: "",
  BottomData: {
    HelpSupportPopup: false,
    new_HelpSupportPopup: false
  }
};

export const WebSocketdataReducer = (state = initialState, action) => {
  switch (action.type) {
    case WEB_SOCKET_DATA:
      return { ...state, WebSocketData: action.payload };

    case ORDER_DATA:
      return { ...state, OrderData: action.payload };

    case BOTTOM_MENU_DATA:
      return {
        ...state,
        BottomData: {
          ...state.BottomData,
          ...action.payload
        }
      };

    default:
      return state;
  }
};
